var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSplitGuestsSolid = function SvgSplitGuestsSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2.25c-1.259 0-2.32.846-2.647 2H7A2.75 2.75 0 0 0 4.25 7v12A2.75 2.75 0 0 0 7 21.75h9.922l-.336-.336A2 2 0 0 1 16 20v-6a2 2 0 0 1 .586-1.414l1-1a2 2 0 0 1 2.158-.442V9.09A.762.762 0 0 0 19.75 9V7A2.75 2.75 0 0 0 17 4.25h-1.354a2.751 2.751 0 0 0-2.646-2h-2ZM9.75 5c0-.69.56-1.25 1.25-1.25h2a1.25 1.25 0 0 1 0 2.5h-2c-.69 0-1.25-.56-1.25-1.25ZM11 14.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm-.5 1a3 3 0 0 0-3 3V20h7v-1.5a3 3 0 0 0-3-3h-1Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.53 12.47a.75.75 0 0 0-1.06 0l-1 1a.75.75 0 0 0 .78 1.237v4.586a.75.75 0 0 0-.78 1.237l1 1a.75.75 0 0 0 1.06 0l1-1a.75.75 0 0 0-.78-1.237v-4.586a.75.75 0 0 0 .78-1.237l-1-1Z",
    fill: "currentColor"
  })));
};
export default SvgSplitGuestsSolid;